import { createElement as rc } from 'react';
import { useTheme } from 'styled-components';
import View from './View';
import PropTypes from 'prop-types';

const Badge = props => {
    const { badge, size, style, ...otherProps } = props;
    const theme = useTheme();

    const badgeSize = size || theme.badge.size;

    const badgeStyle = {
        width: badgeSize,
        height: badgeSize,
        borderRadius: 9999,
        backgroundColor: theme.badge[badge] || 'transparent',
        overflow: 'hidden',
        flexShrink: 0,
        ...style
    };

    return rc(View, { ...otherProps, style: badgeStyle, name: 'badge' });
};

Badge.displayName = 'Badge';

Badge.propTypes = {
    badge: PropTypes.oneOf(['error', 'warning', 'success', 'info', 'none']),
    size: PropTypes.number,
    style: PropTypes.object
};

export default Badge;
